import React, { ReactElement } from 'react'
import Image from '../../../../BaseComponents/Image'

type ImageProps = {
    imageUrl?: string
    alt?: string
}

export const ListTeaserImage = ({ imageUrl, alt }: ImageProps): ReactElement => (
    <Image
        size="S"
        imageUrl={imageUrl}
        alt={alt}
        width="100%"
        radiusType="rounded"
        aspectRatio="1:1"
    />
)
